import loadable from '@loadable/component';

export const LazyCollaborators = loadable(() => import(/* webpackChunkName: "content/guest/collaborators" */ './Collaborators'));
